module.exports = __webpack_public_path__ + "img/main_sub_card.fdd60bca.png";